import { render, staticRenderFns } from "./SiteInactive.vue?vue&type=template&id=61f61790&scoped=true&"
import script from "./SiteInactive.vue?vue&type=script&lang=js&"
export * from "./SiteInactive.vue?vue&type=script&lang=js&"
import style0 from "./SiteInactive.vue?vue&type=style&index=0&id=61f61790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f61790",
  null
  
)

export default component.exports